import actionCreatorFactory from "../util/redux/action-factory";
import { ReduxDispatch } from "./reducers";
import * as request from "../util/request";
import { env } from "../util/env";
import { showSnackbar } from "./snackbar";
import { reducerWithInitialState } from "util/redux/typed-reducers";
import { KYCDataDto, KYCLatestAnswerDateDto, KycDto } from "util/DTOs/KYCDtos";

import { KYCForm } from "types";

const actionFactory = actionCreatorFactory("HypoMobiili/Kyc");
const saveKYCDataAction = actionFactory<KycDto, KycDto, string>("SAVE_KYC");
const getKYCAction = actionFactory<null, KYCForm, string>("GET_KYC");
const getInitialKycStateAction = actionFactory<null, KYCDataDto, string>(
    "GET_KYC_INITIAL_STATE"
);

const getInterestedPartyKycLatestAnswerDateAction = actionFactory<
    null,
    KYCLatestAnswerDateDto,
    string
>("GET_INTERESTED_PARTY_KYC_LATEST_ANSWER_DATE");

export function saveKYCData(data: KycDto) {
    return async (dispatch: ReduxDispatch): Promise<any> => {
        try {
            dispatch(saveKYCDataAction(data));

            const result = await request.put<KycDto>(
                `${env.APP_API_HOST}/api/kyc`,
                data
            );

            dispatch(saveKYCDataAction.done(result));
            dispatch(showSnackbar("Tallennus onnistui"));
            return result;
        } catch (err) {
            dispatch(saveKYCDataAction.failed(""));
            dispatch(showSnackbar("Tallennus epäonnistui"));
            throw err;
        }
    };
}

export function fetchKYCData() {
    return async (dispatch: ReduxDispatch): Promise<KYCForm> => {
        try {
            dispatch(getKYCAction(null));

            const result = await request.get<KYCForm>(
                `${env.APP_API_HOST}/api/forms/1`
            );

            dispatch(getKYCAction.done(result));
            return result;
        } catch (err) {
            dispatch(getKYCAction.failed(err));
            throw err;
        }
    };
}

export function getInitialKycData() {
    return async (dispatch: ReduxDispatch): Promise<KYCDataDto> => {
        try {
            dispatch(getInitialKycStateAction(null));

            const result = await request.get<KYCDataDto>(
                `${env.APP_API_HOST}/api/kyc/data`
            );

            dispatch(getInitialKycStateAction.done(result));
            return result;
        } catch (err) {
            dispatch(getInitialKycStateAction.failed(err));
            throw err;
        }
    };
}

export function getInterestedPartyKycLatestAnswerDate() {
    return async (dispatch: ReduxDispatch): Promise<KYCLatestAnswerDateDto> => {
        try {
            dispatch(getInterestedPartyKycLatestAnswerDateAction(null));
            const result = await request.get<KYCLatestAnswerDateDto>(
                `${env.APP_API_HOST}/api/kyc/latestanswerdate`
            );
            dispatch(getInterestedPartyKycLatestAnswerDateAction.done(result));
            return result;
        } catch (err) {
            dispatch(getInterestedPartyKycLatestAnswerDateAction.failed(err));
            throw err;
        }
    };
}

export interface KYCState {
    loading: boolean;
    form?: KYCForm;
    initialData?: KYCDataDto;
    latestAnswerDate?: KYCLatestAnswerDateDto;
    latestAnswerDateLoading?: boolean;
}

const initialKYCState: KYCState = {
    loading: false,
};

export const KYCReducer = reducerWithInitialState(initialKYCState)
    .case(saveKYCDataAction, (state, action) => {
        return {
            ...state,
            ...action.payload,
            loading: true,
        };
    })
    .case(saveKYCDataAction.done, (state, action) => {
        return {
            ...state,
            loading: false,
        };
    })
    .case(saveKYCDataAction.failed, (state, action) => {
        return {
            ...state,
            loading: false,
        };
    })
    .case(getKYCAction, (state, action) => {
        return {
            ...state,
            loading: true,
        };
    })
    .case(getKYCAction.done, (state, action) => {
        return {
            ...state,
            form: action.payload,
            loading: false,
        };
    })
    .case(getKYCAction.failed, (state, action) => {
        return {
            ...state,
            loading: false,
        };
    })
    .case(getInitialKycStateAction, (state, action) => {
        return {
            ...state,
            loading: true,
        };
    })
    .case(getInitialKycStateAction.done, (state, action) => {
        return {
            ...state,
            initialData: action.payload,
            loading: false,
        };
    })
    .case(getInitialKycStateAction.failed, (state, action) => {
        return {
            ...state,
            loading: false,
        };
    })
    .case(getInterestedPartyKycLatestAnswerDateAction, (state, action) => {
        return {
            ...state,
            latestAnswerDateLoading: true,
        };
    })
    .case(getInterestedPartyKycLatestAnswerDateAction.done, (state, action) => {
        return {
            ...state,
            latestAnswerDate: action.payload,
            latestAnswerDateLoading: false,
        };
    })
    .case(
        getInterestedPartyKycLatestAnswerDateAction.failed,
        (state, action) => {
            return {
                ...state,
                latestAnswerDateLoading: false,
            };
        }
    );

export default KYCReducer;



// WEBPACK FOOTER //
// ./src/ducks/kyc.ts